<template>
    <div>
        <FormKit
            type="hidden"
            :name="`components[${index}][component_type]`"
            :value="component.component_type"
        />

        <FormKit
            label="Titel"
            type="text"
            :name="`components[${index}][title]`"
            :value="component.title"
            @input="(value) => update('title', value)"
        />

        <FormKitCKEditor
            label="Omschrijving"
            :name="`components[${index}][description]`"
            :modelValue="component.description ?? ''"
            @input="(value) => update('description', value)"
        />

        <FormKitImage
            label="Achtergrondafbeelding"
            :name="`components[${index}][background_image]`"
            :value="component.background_image"
            @input="(value) => update('background_image', value)"
        />

        <FormKit
            label="Achtergrondkleur"
            type="color"
            :name="`components[${index}][background_color]`"
            :value="component.background_color"
            @input="(value) => update('background_color', value)"
        />

        <hr />

        <FormKit
            label="Label actief?"
            type="checkbox"
            :name="`components[${index}][label][enable]`"
            v-model="label.enable"
        />

        <FormKit
            label="Label"
            type="text"
            :name="`components[${index}][label][text]`"
            v-model="label.text"
        />

        <FormKit
            label="Label achtergrond kleur"
            type="color"
            :name="`components[${index}][label][background_color]`"
            v-model="label.background_color"
        />

        <FormKit
            label="Label rand kleur"
            type="color"
            :name="`components[${index}][label][border_color]`"
            v-model="label.border_color"
        />

        <FormKit
            label="Label text kleur"
            type="color"
            :name="`components[${index}][label][text_color]`"
            v-model="label.text_color"
        />

        <hr />

        <FormKit
            label="Heeft een knop?"
            type="checkbox"
            :name="`components[${index}][has_button]`"
            :value="!!component.has_button"
            @input="(value) => update('has_button', value)"
        />

        <FormKit
            label="Knop label"
            type="text"
            :name="`components[${index}][button_label]`"
            :value="component.button_label"
            @input="(value) => update('button_label', value)"
        />

        <FormKit
            label="Knop link"
            type="text"
            :name="`components[${index}][button_link]`"
            :value="component.button_link"
            @input="(value) => update('button_link', value)"
        />

        <FormKit
            label="Open link in nieuw venster?"
            type="checkbox"
            :name="`components[${index}][button_open_in_new_window]`"
            :value="!!component.button_open_in_new_window"
            @input="(value) => update('button_open_in_new_window', value)"
        />
       
        <br />

        <FormKit
            label="Knop textkleur"
            type="color"
            :name="`components[${index}][button_text_color]`"
            :value="component.button_text_color"
            @input="(value) => update('button_text_color', value)"
        />

        <FormKit
            label="Knop achtergrondkleur"
            type="color"
            :name="`components[${index}][button_background_color]`"
            :value="component.button_background_color"
            @input="(value) => update('button_background_color', value)"
        />
    </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
    name: "PageBanner",
    mixins: [mixin],
    data() {
        let label = {
            text: "",
            background_color: "",
            border_color: "",
            text_color: "",
            ...(this.modelValue?.label ?? {}),
            enable: !!this.modelValue?.label?.enable ?? false,
        };

        return {
            label,
        };
    },
    watch: {
        label: {
            deep: true,
            handler(label) {
                this.update("label", label);
            },
        },
    },
};
</script>
